export const StringTemplate = (
  stringTemplate: string,
  replacementStr: string,
  ...args: string[]
): string => {
  let resultString = stringTemplate;

  args.forEach((arg) => {
    resultString = resultString.replace(replacementStr, arg);
  });

  return resultString;
};
